import React from "react";
import "../Css/StudentReview.css";

const StudentReview = () => {
  return (
    <section className="review-section">

      <h2 className="review-title">Student Review</h2>

      <div className="review-grid">

        <div className="review-video">
          <iframe
            src="https://www.youtube.com/embed/7_5hZvwjGAc"
            title="Student Review 2"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>


        <div className="review-video">
          <iframe
           src="https://www.youtube.com/embed/n1vfJfwc4IY"
            title="Student Review 2"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>

        <div className="review-video">
          <iframe
            src="https://www.youtube.com/embed/Ivf4Tk_WDcI"
            title="Student Review 1"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>


      </div>

    </section>
  );
};

export default StudentReview;